import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import './styles/app.css';
import * as APP_DATA from './assets/data/constants';
import FamilyTree from './components/FamilyTree';

const App = () => {
  const { sections, menuItems, profile, components } = APP_DATA.app;
  const DefaultComponent = components.about;
  const defaultComponentData = APP_DATA.about;

  const location = useLocation();

  // Check if we're on the family-tree route
  const isFamilyTreeRoute = location.pathname === '/family-tree';

  // If on family tree route, render it fullscreen without the portfolio layout
  if (isFamilyTreeRoute) {
    return <FamilyTree />;
  }

  return (
    <>
      <div className="preloader" style={{ display: 'none' }}>
        <div className="centrize full-width">
          <div className="vertical-center">
            <div className="spinner">
              <div className="double-bounce1"></div>
              <div className="double-bounce2"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="page new-skin">
        <div className="background gradient">
          <ul className="bg-bubbles">
            {[...Array(10)].map((_, i) => (
              <li key={i}></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="profile-page-container">
        <div className="container">
          <div className="profile-middle-section">
            <header className="header">
              <div className="profile">
                <div className="title">Gaurav Gupta</div>
                <div className="subtitle subtitle-typed">
                  <div className="subtitle subtitle-typed">SE</div>
                </div>
              </div>
              <div className="top-menu menu-minimal">
                <ul>
                  {menuItems.map((item, index) => (
                    <li
                      key={item.id}
                      className={
                        location.pathname === `/${item.id}` ||
                        (index === 0 && location.pathname === '/')
                          ? 'active'
                          : ''
                      }
                    >
                      <Link to={`/${item.id}`} id={item.id}>
                        <span className={`icon fa ${item.icon}`}></span>
                        <span className="link">{item.text}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </header>
            <div className="col-left">
              <div className="card-started" id="home-card">
                <div className="profile no-photo">
                  <div className="slide texting"></div>
                  <div className="title">{profile.name}</div>
                  <div className="subtitle subtitle-typed">{profile.title}</div>
                  <div className="social">
                    {profile.socialLinks.map((link, index) => (
                      <a key={index} target="_blank" href={link.url} rel="noopener noreferrer">
                        <span className={`fa ${link.icon}`}></span>
                      </a>
                    ))}
                  </div>
                  <div className="lnks">
                    <a
                      target="_blank"
                      href={profile.resume.file}
                      rel="noopener noreferrer"
                      className="lnk"
                    >
                      <span className="text">{profile.resume.text}</span>
                      <i className="fa fa-cloud-download" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-Right">
              <TransitionGroup component={null}>
                <CSSTransition key={location.key} classNames="animate" timeout={1000}>
                  <Routes>
                    {sections.map(section => {
                      const Component = components[section];
                      return (
                        <Route
                          key={section}
                          path={`/${section}`}
                          element={<Component data={APP_DATA[section]} />}
                        />
                      );
                    })}
                    <Route path="/" element={<DefaultComponent data={defaultComponentData} />} />
                  </Routes>
                </CSSTransition>
              </TransitionGroup>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default App;
